import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Card, Flex, Spin, Empty, Tag, Typography, message, notification } from 'antd'

import Main from '../components/Main'
import { BILLING_SUMMARY, BILLING_CHARGE_SENT, requestToServer, getLocalData } from '../lib/helper'
import { paymetMethod } from '../config'
import { PLANS, PERIODS, dueTag, fmtDay, fmtStamp, fmtMoney, fmtMoneyMap } from '../lib/billing'
import PaymentModal from '../components/PaymentModal'

// Task007: la lista de trabajo de cobros. No hay cron ni correos: esta pantalla y el contador de Home son la única
// forma de enterarse, por eso las secciones van en orden de urgencia y "Sin configurar" lleva su propio conteo.

// una card por clon. Va fuera de la pantalla: si se definiera adentro se remontaría en cada render.
const CloneCard = ({ item: c, onPay, onChargeSent, onOpen }) => {
  const due = c.due
  return (
    <Card size='small' style={{ marginBottom: 10, overflowWrap: 'anywhere' }}>
      <Flex justify='space-between' align='flex-start' gap='small' wrap='wrap'>
        <div>
          <strong>{c.platformName}</strong>{ c.clientName && <span> · {c.clientName}</span> }<br/>
          <span style={{ color: '#888' }}>
            { c.plan ? PLANS[c.plan] : 'Sin plan' } · { c.billingPeriod ? PERIODS[c.billingPeriod] : 'sin período' } · { fmtMoney(c.amount, c.currency) }
          </span>
        </div>
        <Flex gap='small' align='center' wrap='wrap'>
          { due.autoCharge && <Tag style={{ marginInlineEnd: 0 }}>PayPal automático</Tag> }
          { dueTag(due) }
        </Flex>
      </Flex>

      <div style={{ marginTop: 6 }}>
        {/* el separador "·" solo va si hay algo antes: sin método de pago quedaba un punto colgando */}
        { c.nextDueDate && <span>Vence: {fmtDay(c.nextDueDate)}</span> }
        { c.paymentType && <span>{ c.nextDueDate ? ' · ' : '' }{paymetMethod[c.paymentType] || c.paymentType}</span> }
        { c.subscriptionId && <span style={{ color: '#888' }}>{ ( c.nextDueDate || c.paymentType ) ? ' · ' : '' }{c.subscriptionId}</span> }
      </div>

      {/* el olvido del link: se ve de un vistazo si ya se mandó el cobro de este ciclo */}
      { due.needsCharge && <Tag color='red' style={{ marginTop: 6 }}>Cobro sin enviar</Tag> }
      { c.chargeSentAt && !due.autoCharge && <div style={{ color: '#888', marginTop: 4 }}>Cobro enviado el {fmtStamp(c.chargeSentAt)}</div> }
      { due.autoCharge && ['overdue', 'suspend_now'].includes(due.status) &&
        <Tag color='orange' style={{ marginTop: 6 }}>Verifica en PayPal si la suscripción falló</Tag> }

      <Flex gap='small' wrap='wrap' style={{ marginTop: 8 }}>
        <Button size='small' type='primary' onClick={() => onPay(c)}>Registrar pago</Button>
        { c.billingState === 'active' && !due.autoCharge && !c.chargeSentAt &&
          <Button size='small' onClick={() => onChargeSent(c)}>Cobro enviado</Button> }
        <Button size='small' onClick={() => onOpen(c)}>Ver ficha</Button>
      </Flex>
    </Card>
  )
}

export default () => {
  const history = useHistory()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [paying, setPaying] = useState(null)   // el clon al que se le registra un pago

  const load = () => {
    setLoading(true)
    requestToServer({}, BILLING_SUMMARY).then(setData).catch(()=>{}).finally(() => setLoading(false))
  }
  // Revisión 10: sin sesión, al login (mismo patrón que Leads.js)
  useEffect(() => {
    const localData = getLocalData()
    if ( !localData || !localData.token ) { history.push('/login'); return }
    load()
  }, [])

  const chargeSent = (c) => requestToServer({ platformName: c.platformName, sent: true }, BILLING_CHARGE_SENT)
    .then( () => { message.info('Cobro marcado como enviado: ' + c.platformName); load() } )
    .catch(()=>{})

  const visible = data ? data.sections.filter( s => s.items.length > 0 ) : []

  return (
    <Main pageHeader={{ title: 'Cobros', back: true }}>

      <Spin spinning={loading}>
        { data && <>

          <Card size='small' style={{ marginBottom: 10 }}>
            <div>Cobrado en {data.totals.month}: <strong>{fmtMoneyMap(data.totals.collected)}</strong></div>
            <div>
              Pendiente este mes: <strong>{fmtMoneyMap(data.totals.pending)}</strong> ({data.totals.pendingCount} clon(es)
              { data.totals.pendingNoAmount > 0 && <span>, {data.totals.pendingNoAmount} sin monto cargado</span> })
            </div>
            <div style={{ color: '#888', marginTop: 4 }}>
              Al día {data.counts.ok} · Exentos {data.counts.exempt} · Suspendidos {data.counts.suspended} · De baja {data.counts.closed} · Total {data.counts.total}
            </div>
          </Card>

          { visible.length === 0 && <Empty description='Nada pendiente' /> }

          { visible.map( s => (
            <div key={s.key} style={{ marginBottom: 14 }}>
              <div style={{ fontWeight: 'bold', fontSize: 16 }}>{s.title} ({s.items.length})</div>
              <Typography.Text type='secondary'>{s.hint}</Typography.Text>
              <div style={{ marginTop: 6 }}>
                {/* Revisión 11: "Sin configurar" puede tener ~60 clones durante la carga inicial: va como lista
                    compacta de enlaces a la ficha (ahí se configura), no como cards completas */}
                { s.key === 'setup'
                  ? <Flex gap='small' wrap='wrap'>
                      { s.items.map( c => (
                        <Button key={c.id} size='small' onClick={() => history.push('/clone/' + c.platformName)}>
                          {c.platformName}
                        </Button>
                      ) ) }
                    </Flex>
                  : s.items.map( c => (
                      <CloneCard key={c.id} item={c} onPay={setPaying} onChargeSent={chargeSent}
                        onOpen={ x => history.push('/clone/' + x.platformName) } />
                    ) ) }
              </div>
            </div>
          ) ) }

        </> }
      </Spin>

      <PaymentModal
        open={!!paying}
        clone={paying}
        prices={data && data.prices}
        onClose={() => setPaying(null)}
        onDone={ r => {
          setPaying(null)
          load()
          if ( r.wasSuspended ) {
            notification.warning({
              message: 'El clon estaba suspendido',
              description: 'El pago reactivó el cobro, pero la plataforma sigue detenida: levántala desde su ficha.'
            })
          }
        }}
      />

    </Main>
  )
}
